import axios from "axios";
export default {
  // fetch all data of client
  async fetchUserData({ commit }) {
    const response = await axios.post(`web/profile`);
    commit("SET_CLIENT", response.data.user.user_client.client);
    commit("SET_IS_CLIENT", response.data.user.user_client.master);
    commit("SET_USER", response.data.user);
    commit("SET_SUB_CLIENT", response.data.sub_client);
    commit("SET_SUB_USER", response.data.sub_user);
    commit("SET_RESPONSIBLE_BRANCH", response.data.responsibleBranch);
    commit("SET_GOVERNMENT", response.data.government);
    commit("SET_HAVE_STOCK", response.data.have_stock);
    commit("SET_NEW_SUPPORT_SYSTEM_USER", response.data.new_support_system_user);
    commit("SET_SUPPORT_SYSTEM_USER_ID", response.data.support_system_user_id);
    localStorage.setItem("haveStock", response.data.have_stock);
  },
  //fetch User Balance
  async userBalance({commit}){
    const response = await axios.get(`/balance`);
    commit("SET_NEXT_SUPPLY", response.data.feed.next_supply);
    commit("SET_TOTAL_SUPPLIED_BALANCE", response.data.feed.total_supplied_balance);
    commit("SET_TOTAL_BALANCE", response.data.feed.total_balance);
  },

  // fetch all locations of client
  async clientLocations({ commit }) {
    await axios
      .get(`/locations`)
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          commit("SET_CLIENT_LOCATIONS", res.data.feed.data);
          commit("SET_SUCCESS_API", 1);
          commit("ERROR_MSG", "");
        }
      })
      .catch((e) => {
        commit("SET_SUCCESS_API", 0);
        commit("ERROR_MSG", e.response.data.error_msg);
      });
  },

};
